import React from 'react'
import './App.css'
import Routes from './routes'
import { BrowserRouter as Router } from 'react-router-dom'
import { SnackbarProvider, useSnackbar } from 'notistack'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import i18n from './Utils/LanguageManager/language-i18n'
import { I18nextProvider } from 'react-i18next'

const ScrollToTop = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}

const SnackbarCloseButton = ({ snackbarKey }) => {
    const { closeSnackbar } = useSnackbar()

    return (
        <button
            onClick={() => closeSnackbar(snackbarKey)}
            style={{
                border: 'none',
                background: 'transparent',
                color: 'white',
                cursor: 'pointer',
                marginLeft: 10,
            }}
        >
            ✖
        </button>
    )
}

const App = () => {
    return (
        <div className="App">
            <I18nextProvider i18n={i18n}>
                <SnackbarProvider
                    maxSnack={1}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}
                >
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <Router>
                            <Routes />
                        </Router>
                    </MuiPickersUtilsProvider>
                </SnackbarProvider>
            </I18nextProvider>
        </div>
    )
}

export default App
